import { useNavigate, useParams, Outlet, useLocation } from "react-router-dom";
import { useBase } from "../../../../store/useBase";

// Modularized Components
import Sidebar from "../../../siteExhibitors/Sidebar";
import HeroBanner from "../../../siteExhibitors/HeroBanner";
import MobileBottomNav from "../../../siteExhibitors/MobileBottomNav";
import { Header1 } from "../../comp/themes/modern/home/header/Header1";
import { useSite } from "../../../../store/useSite";
import { useExhSpaceStore } from "../../../../store/useExhSpaceStore";
import { useEffect } from "react";

export default function ExhibitorSpace() {
  const { eventId, siteSlug } = useBase();
  const {
    siteUser,
    isExhibitor,
    setProfileSettingPopup,
    setProfileModalMode,
    siteUserLoading,
    isExhibitorSpace,
    profileSettingPopup,
  } = useSite();

  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract active tab from URL path (robust for Outlets)
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];
  const activeTab = lastSegment === "space" ? "overview" : (lastSegment || "overview");

  const { boothMembers, permissions, fetchPermissions, setCurrentExhibitorId } = useExhSpaceStore();

  useEffect(() => {
    if (eventId && !siteUserLoading) {
      if (!siteUser) {
        navigate(`/${siteSlug}/signin`);
      } else if (!isExhibitor || !isExhibitorSpace) {
        navigate(`/${siteSlug}`);
      } 
    }
  }, [eventId, siteUser, siteUserLoading, siteSlug, isExhibitor, isExhibitorSpace, navigate]);

  useEffect(() => {
    if (siteUser?.exhibitor?.id) {
      setCurrentExhibitorId(siteUser.exhibitor.id);
    }
  }, [siteUser?.exhibitor?.id, setCurrentExhibitorId]);
  
  
  useEffect(() => {
    if (eventId && siteUser?.role_id) {
      fetchPermissions(eventId, siteUser.role_id);
    }
  }, [eventId, siteUser?.role_id]);

  const handleTabChange = (newTab, options = {}) => {
    if (newTab === "ticket") {
      navigate(`/${siteSlug}/your-tickets`, options);
      return;
    }
    navigate(`/${siteSlug}/exhibitor/space/${newTab}`, options);
  };

  const exhibitor = {
    name: siteUser?.exhibitor?.name || "",
    category_name: siteUser?.exhibitor_category?.categoryname || "Exhibitor",
    booth_number: siteUser?.exhibitor?.booth_number || "A1",
    booth_size: siteUser?.exhibitor?.booth_size || "10 ft x 10 ft",
    website_url: siteUser?.exhibitor?.website,
    logo: siteUser?.exhibitor?.logo,
    banner: siteUser?.exhibitor?.banner_url,
    description: siteUser?.exhibitor?.company_description || "No description provided.",
    company_description: siteUser?.exhibitor?.company_description,
    company_overview: siteUser?.exhibitor?.company_overview,
    email: siteUser?.exhibitor?.primary_contact_email,
    phone: siteUser?.exhibitor?.primary_contact_phone,
    social_links: siteUser?.exhibitor?.social_links,
    slug: siteUser?.exhibitor?.slug,
  };

  return (
    <div className="min-h-screen bg-[#f3f4f6] flex flex-col font-inter text-gray-900 scroll-smooth selection:bg-primary-color/10 selection:text-primary-color">
      {/* QuickStream Main Header */}
      <Header1 />

      {/* Hero Banner Area */}
      <HeroBanner
        exhibitor={exhibitor}
        siteSlug={siteSlug}
        onEditProfile={() => {
            setProfileModalMode("edit");
            setProfileSettingPopup(true);
        }}
        onOpenOnboarding={() => {
            setProfileModalMode("auto");
            setProfileSettingPopup(true);
        }}
        exhibitor_id={siteUser?.exhibitor?.id}
      />

      {/* Main Workspace */}
      <main className="max-w-7xl mx-auto w-full px-4 py-4 md:px-8 flex flex-col md:flex-row gap-3">
        {/* Desktop Sidebar (Hidden on Mobile as Bottom Nav replaces it) */}
        <div className="hidden md:block">
          <Sidebar
            activeTab={activeTab}
            onTabChange={handleTabChange}
            isMobile={false}
            features={siteUser?.exhibitor_category?.features || []}
          />
        </div>

        {/* Global Tab Content Area */}
        <div className="flex-grow pb-20 md:p-0">
          <div className="w-full">
            <Outlet
              context={{
                exhibitor,
                boothMembers,
                permissions,
                siteUser,
                setProfileSettingPopup,
                handleTabChange,
                eventId,
                siteSlug,
                siteId: siteUser?.eventId,
              }}
            />
          </div>
        </div>
      </main>

      {/* High-Velocity Mobile Bottom Navigation: Contextual Safe Area */}
      {!profileSettingPopup && (
        <MobileBottomNav
          activeTab={activeTab}
          onTabChange={handleTabChange}
          features={siteUser?.exhibitor_category?.features || []}
        />
      )}
      {/* <ToastContainer /> */}
    </div>
  );
}
